import { Navigate, useLocation } from "react-router-dom";

function FamilyVerify({ children }) {
  const location = useLocation();
  const fromPage = location.state?.from;

  if (fromPage !== "login" && fromPage !== "signup") {
    // Redirect to login page if not coming from login or signup
    return <Navigate to="/family_login" replace />;
  }

  // If coming from login or signup, render the children (OTP page)
  return children;
}

export default FamilyVerify;